// @flow
import React, { useEffect, useState } from 'react';
import ReactPasswordStrengthBar from 'react-password-strength-bar';
// $FlowFixMe
import $ from 'jquery';
import styled from 'styled-components';

const PasswordContainerThreeBars = styled.div`
  > div > div > div:nth-last-child(-n + 2) {
    display: none;
  }
  > div > div > div:nth-child(even) {
    // is being overwritten by another style element
    width: 2px !important;
  }
`;

type Props =
  | {
      password: string,
    }
  | {
      selector: string,
    };

const PasswordStrengthBar = (props: Props) => {
  const [password, setPassword] = useState('');

  useEffect(() => {
    if (props.selector) {
      $(props.selector).on('keyup', e => {
        setPassword(e.target.value);
      });
    }
  });

  return (
    <PasswordContainerThreeBars>
      <ReactPasswordStrengthBar
        scoreWords={[]}
        barColors={['#ddd', '#d8372a', '#f2cd00', '#008561', '#008561']}
        shortScoreWord={''}
        password={password}
        {...props}
      />
    </PasswordContainerThreeBars>
  );
};

export default PasswordStrengthBar;
